import colorTool from '@/utils/color';
export default {
  name: 'App',
  data() {
    return {
      config: {
        size: "default",
        zIndex: 2000,
        button: {
          autoInsertSpace: false
        }
      },
      routerAlive: true
    };
  },
  //暴露 reload 这个方法，方便组件调用
  provide() {
    return {
      reload: this.reload
    };
  },
  computed: {
    locale() {
      return this.$i18n.messages[this.$i18n.locale].el;
    }
  },
  created() {
    //设置主题颜色
    const app_color = this.$CONFIG.COLOR || this.$TOOL.data.get('APP_COLOR');
    if (app_color) {
      document.documentElement.style.setProperty('--el-color-primary', app_color);
      for (let i = 1; i <= 9; i++) {
        document.documentElement.style.setProperty(`--el-color-primary-light-${i}`, colorTool.lighten(app_color, i / 10));
      }
      for (let i = 1; i <= 9; i++) {
        document.documentElement.style.setProperty(`--el-color-primary-dark-${i}`, colorTool.darken(app_color, i / 10));
      }
    }
  },
  methods: {
    //重新加载的方法
    reload() {
      this.routerAlive = false;
      this.$nextTick(function () {
        this.routerAlive = true;
      });
    }
  }
};